<template>
    <div>
        <CRow>
            <CCol col="12">
                <CCard>
                    <CCardHeader>پروفایل</CCardHeader>
                        <CCardBody>
                            <CTabs variant="pills">
                                <CTab title="مشخصات کاربر" active class="mb">
                                    <CRow>
                                        <CCol sm="12">
                                            <CCard>
                                                <CCardBody>
                                                    <CDataTable striped small fixed :items="users" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }" />
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </CTab>
                                <CTab title="تنظیمات">
                                    <CRow>
                                        <CCol sm="12">
                                            <CCard>
                                                <CCardBody>
                                                    <CDataTable striped small fixed :items="settings" :fields="fields" :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }" />
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </CTab>
                                <CTab title="شماره‌ها">
                                    <CRow>
                                        <CCol sm="12">
                                            <CCard>
                                                <CCardBody>
                                                    <CDataTable striped small fixed :items="numbers" :fields="number_fields" :items-per-page="10" :active-page="active_page" :pagination="{ doubleArrows: true, align: 'center'}" columnFilter :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                                                        <template #gateway_name="data">
                                                            <td v-if="$store.state.perms.can_request_gateway_info">{{data.item.gateway_name}}</td>
                                                            <td v-else>---</td>
                                                        </template>
                                                        <template #is_active="data">
                                                            <td v-if="data.item.is_active">
                                                                <CIcon name="cilCheckAlt" size="lg"/>
                                                            </td>
                                                            <td v-else>
                                                                <CIcon name="cilX" size="lg"/>
                                                            </td>
                                                        </template>
                                                        <template #url_check="data">
                                                            <td v-if="data.item.url_check">
                                                                <CIcon name="cilCheckAlt" size="lg"/>
                                                            </td>
                                                            <td v-else>
                                                                <CIcon name="cilX" size="lg"/>
                                                            </td>
                                                        </template>
                                                        <template #is_confirme="data">
                                                            <td v-if="data.item.is_confirme">
                                                                <CIcon name="cilCheckAlt" size="lg"/>
                                                            </td>
                                                            <td v-else>
                                                                <CIcon name="cilX" size="lg"/>
                                                            </td>
                                                        </template>
                                                        <template #is_service="data">
                                                            <td v-if="data.item.is_service">
                                                                <CIcon name="cilCheckAlt" size="lg"/>
                                                            </td>
                                                            <td v-else>
                                                                <CIcon name="cilX" size="lg"/>
                                                            </td>
                                                        </template>
                                                        <template #is_global="data">
                                                            <td v-if="data.item.is_global">
                                                                <CIcon name="cilCheckAlt" size="lg"/>
                                                            </td>
                                                            <td v-else>
                                                                <CIcon name="cilX" size="lg"/>
                                                            </td>
                                                        </template>
                                                        <template #can_receive="data">
                                                            <td v-if="data.item.can_receive">
                                                                <CIcon name="cilCheckAlt" size="lg"/>
                                                            </td>
                                                            <td v-else>
                                                                <CIcon name="cilX" size="lg"/>
                                                            </td>
                                                        </template>
                                                        <template #delivery_base="data">
                                                            <td v-if="data.item.delivery_base">
                                                                <CIcon name="cilCheckAlt" size="lg"/>
                                                            </td>
                                                            <td v-else>
                                                                <CIcon name="cilX" size="lg"/>
                                                            </td>
                                                        </template>
                                                        <template #check_blacklist="data">
                                                            <td v-if="data.item.check_blacklist">
                                                                <CIcon name="cilCheckAlt" size="lg"/>
                                                            </td>
                                                            <td v-else>
                                                                <CIcon name="cilX" size="lg"/>
                                                            </td>
                                                        </template>
                                                    </CDataTable>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </CTab>
                            <CTab title="لینک‌ها">
                                <CRow>
                                    <CCol sm="12">
                                        <CCard>
                                            <CCardBody>
                                                <CDataTable striped small fixed :items="links" :fields="link_fields" :items-per-page="10" :active-page="active_page" :pagination="{ doubleArrows: true, align: 'center'}" columnFilter :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                                                    <template #is_active="data">
                                                        <td v-if="data.item.is_active">
                                                            <CIcon name="cilCheckAlt" size="lg"/>
                                                        </td>
                                                        <td v-else>
                                                            <CIcon name="cilX" size="lg"/>
                                                        </td>
                                                    </template>
                                                    <template #current_state="data">
                                                        <td v-if="data.item.current_state">
                                                            <CIcon name="cilCheckAlt" size="lg"/>
                                                        </td>
                                                        <td v-else>
                                                            <CIcon name="cilX" size="lg"/>
                                                        </td>
                                                    </template>
                                                </CDataTable>
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                            </CTab>
                            <CTab title="توکن‌ها">
                                <CRow>
                                    <CCol sm="12">
                                        <CCard>
                                            <CCardBody>
                                                <CDataTable striped small fixed :items="tokens" :fields="token_fields" :items-per-page="10" :active-page="active_page" :pagination="{ doubleArrows: true, align: 'center'}" columnFilter :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }" />
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                            </CTab>
                            <CTab title="تعرفه‌ها">
                                <CRow>
                                    <CCol sm="12">
                                        <CCard>
                                        <CCardBody>
                                            <CDataTable striped small fixed :items="fees" :fields="fee_fields" :items-per-page="10" :active-page="active_page" :pagination="{ doubleArrows: true, align: 'center'}" columnFilter :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }">
                                                <template #action="data">
                                                    <td>
                                                        <template>
                                                        <div class="flex-container">
                                                            <div @click="fee_name=data.item.name;fee_detail=data.item.fee_infos;fee_modal=true;"
                                                                v-c-tooltip.hover="'جزییات'">
                                                                <CIcon name="cilListRich" size="lg"/>
                                                            </div>
                                                        </div>
                                                        </template>
                                                    </td>
                                                </template>
                                        </CDataTable>
                                        </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                            </CTab>
                        </CTabs>
                    </CCardBody>
                    <CCardFooter>
                        <CButton v-show="can_update" color="primary"
                            @click="redirect_to(`/user/${$route.params.id}/edit`)">ویرایش مشخصات</CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            :title="fee_name"
            size="lg"
            color="primary"
            :show.sync="fee_modal"
            >
            <CDataTable
                striped
                small
                fixed
                :items="fee_detail"
                :fields="[
                    { key: 'id', label: 'شناسه' },
                    { key: 'mobile_operator_id', label: 'اپراتور' },
                    { key: 'fee_en', label: 'تعرفه انگلیسی (ریال)' },
                    { key: 'fee_fa', label: 'تعرفه فارسی (ریال)' },
                ]"
                :items-per-page="5"
                :active-page="active_page"
                :pagination="{ doubleArrows: false, align: 'center'}"
                :noItemsView="{ noItems: 'داده‌ای برای نمایش وجود ندارد' }"
            /> 
            <template #footer>
                <CButton @click="fee_modal=false" color="primary">بستن</CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            users: [],
            settings: [],
            can_update: false,
            number_fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'number', label: 'شماره' },
                { key: 'gateway_name', label: 'درگاه' },
                { key: 'operators_fee_name', label: 'تعرفه' },
                { key: 'is_active', label: 'وضعیت' },
                { key: 'url_check', label: 'URL check' },
                { key: 'is_confirme', label: 'is confirme' },
                { key: 'is_service', label: 'is service' },
                { key: 'is_global', label: 'is global' },
                { key: 'can_receive', label: 'can receive' },
                { key: 'delivery_base', label: 'delivery base' },
                { key: 'check_blacklist', label: 'check blacklist' },
                { key: 'last_used', label: 'آخرین استفاده' },
            ],
            numbers: [],
            link_fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'url_link', label: 'لینک' },
                { key: 'is_active', label: 'وضعیت' },
                { key: 'current_state', label: 'وضعیت جاری' },
                { key: 'created_at', label: 'تاریخ ایجاد' },
                { key: 'last_send', label: 'آخرین ارسال' },
            ],
            links: [],
            token_fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'limit', label: 'محدودیت' },
                { key: 'ip', label: 'IP' },
                { key: 'last_used', label: 'آخرین استفاده' },
                { key: 'created_at', label: 'تاریخ ایجاد' },
            ],
            tokens: [],
            fee_fields: [
                { key: 'id', label: 'شناسه' },
                { key: 'name', label: 'نام' },
                { key: 'action', label: 'جزییات' },
            ],
            fees: [],
            fee_name: '',
            fee_detail: [],
            fee_modal: false,
            active_page: 1,
        }
    },
    computed: {
        fields() {
            return [
                { key: 'key', label: '', _style: 'width:150px' },
                { key: 'value', label: '', _style: 'width:150px;' }
            ]
        }
    },
    mounted() {
        this.get_user();
        this.get_numbers();
        this.get_links();
        this.get_token();
        this.get_fees();
    },
    methods: {
        get_user() {
            this.axios.get('/users/' +
                    '?id=' + this.$route.params.id +
                    '&user_settings=1')
                .then(res => {
                    res.data.map(val => {
                        if (val.user_settings.account_setting_info.send_emergency_sms) {
                            val.user_settings.account_setting_info.send_emergency_sms = 'فعال';
                        } else {
                            val.user_settings.account_setting_info.send_emergency_sms = 'غیرفعال';
                        }
                        this.settings.push({ key: 'ارسال پیام‌ اطلاع‌رسانی', value: val.user_settings.account_setting_info.send_emergency_sms }, { key: 'شماره موبایل', value: val.user_settings.account_setting_info.send_emergency_sms_to }, { key: 'محدودیت شارژ (ریال)', value: String(val.user_settings.account_setting_info.account_balance_limit).replace(/\B(?=(\d{3})+(?!\d))/g, ",") });

                        this.can_update = val.can_update;
                        this.users.push({ key: 'شناسه', value: val.id }, { key: 'نام', value: val.first_name }, { key: 'نام خانوادگی', value: val.last_name });
                        if (val.is_hoghoghi) {
                            this.users.push({ key: 'نام پدر', value: val.user_settings.hoghoghi_account_info.sherkat_rabet_name_pedar });
                        } else {
                            this.users.push({ key: 'نام پدر', value: val.user_settings.haghighi_account_info.fathername });
                        }
                        this.users.push({ key: 'کد ملی', value: val.national_code });
                        if (val.is_hoghoghi) {
                            this.users.push({ key: 'شماره شناسنامه', value: val.user_settings.hoghoghi_account_info.sherkat_rabet_shomare_shenasname });
                        } else {
                            this.users.push({ key: 'شماره شناسنامه', value: val.user_settings.haghighi_account_info.shenasname_no });
                        }
                        if (val.is_hoghoghi) {
                            this.axios.get('/cities/' +
                                    '?id=' + val.user_settings.hoghoghi_account_info.sherkat_rabet_tavalod_city)
                                .then(res => {
                                    this.users.push({ key: 'محل تولد', value: res.data[0].name });
                                })
                        } else {
                            this.axios.get('/cities/' +
                                    '?id=' + val.user_settings.haghighi_account_info.tavalod_city)
                                .then(res => {
                                    this.users.push({ key: 'محل تولد', value: res.data[0].name });
                                })
                        }

                        if (val.is_hoghoghi) {
                            if (val.user_settings.hoghoghi_account_info.sherkat_rabet_tavalod_date == '0001-01-01T00:00:00Z') {
                                this.users.push({ key: 'تاریخ تولد', value: '---' });
                            } else {
                                this.users.push({ key: 'تاریخ تولد', value: this.$moment(val.user_settings.hoghoghi_account_info.sherkat_rabet_tavalod_date, 'YYYY-MM-DD').locale('fa').format('jYYYY-jMM-jDD') });
                            }
                        } else {
                            if (val.user_settings.haghighi_account_info.tavalod_date == '0001-01-01T00:00:00Z') {
                                this.users.push({ key: 'تاریخ تولد', value: '---' });
                            } else {
                                this.users.push({ key: 'تاریخ تولد', value: this.$moment(val.user_settings.haghighi_account_info.tavalod_date, 'YYYY-MM-DD').locale('fa').format('jYYYY-jMM-jDD') });
                            }
                        }
                        this.users.push({ key: 'ایمیل', value: val.email }, { key: 'شماره موبایل', value: val.username });
                        if (val.is_hoghoghi) {
                            this.users.push({ key: 'شماره تلفن', value: val.user_settings.hoghoghi_account_info.sherkat_tell });
                        } else {
                            this.users.push({ key: 'شماره تلفن', value: val.user_settings.haghighi_account_info.tell });
                        }
                        if (val.is_hoghoghi) {
                            this.users.push({ key: 'فکس', value: val.user_settings.hoghoghi_account_info.sherkat_fax });
                        } else {
                            this.users.push({ key: 'فکس', value: val.user_settings.haghighi_account_info.fax });
                        }
                        if (val.is_active) {
                            val.is_active = 'فعال';
                        } else {
                            val.is_active = 'غیرفعال';
                        }

                        this.users.push({ key: 'وضعیت', value: val.is_active }, { key: 'کد پستی', value: val.postcode });

                        if (val.is_hoghogh) {
                            this.axios.get('/provinces/' +
                                    '?id=' + val.user_settings.hoghoghi_account_info.sherkat_ostan)
                                .then(res => {
                                    this.users.push({ key: 'استان', value: res.data[0].name });
                                })
                        } else {
                            this.axios.get('/provinces/' +
                                    '?id=' + val.user_settings.haghighi_account_info.ostan_id)
                                .then(res => {
                                    this.users.push({ key: 'استان', value: res.data[0].name });
                                })
                        }
                        this.axios.get('/cities/' +
                                '?id=' + val.city_id)
                            .then(res => {
                                this.users.push({ key: 'شهر', value: res.data[0].name });
                            })
                        this.users.push({ key: 'آدرس', value: val.address }, { key: 'تاریخ ایجاد', value: this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD') });

                        if (val.last_login == '0001-01-01T00:00:00Z') {
                            this.users.push({ key: 'آخرین ورود', value: '---' });
                        } else {
                            this.users.push({ key: 'آخرین ورود', value: this.$moment(val.last_login, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD') });
                        }
                        this.users.push({ key: 'موجودی حساب (ریال)', value: String(val.account_balance).replace(/\B(?=(\d{3})+(?!\d))/g, ",") });
                        if (val.is_hoghoghi) {
                            this.users.push({ key: 'کاربر حقوقی', value: 'بله' });
                        } else {
                            this.users.push({ key: 'کاربر حقوقی', value: 'خیر' });
                        }
                        if (val.access_web_service) {
                            this.users.push({ key: 'دسترسی به وب‌سرویس', value: 'فعال' });
                        } else {
                            this.users.push({ key: 'دسترسی به وب‌سرویس', value: 'غیرفعال' });
                        }
                        if (val.is_verified) {
                            this.users.push({ key: 'تایید کاربر', value: 'فعال' });
                        } else {
                            this.users.push({ key: 'تایید کاربر', value: 'غیرفعال' });
                        }
                        if (val.is_hoghoghi) {
                            switch (val.user_settings.hoghoghi_account_info.sherkat_type) {
                                case 1:
                                    this.users.push({ key: 'نوع شرکت', value: 'سهامی عام' });
                                    break;
                                case 2:
                                    this.users.push({ key: 'نوع شرکت', value: 'سهامی خاص' });
                                    break;
                                case 3:
                                    this.users.push({ key: 'نوع شرکت', value: 'مسئولیت محدود' });
                                    break;
                                case 4:
                                    this.users.push({ key: 'نوع شرکت', value: 'تضامنی' });
                                    break;
                                case 5:
                                    this.users.push({ key: 'نوع شرکت', value: 'مختلط غیرسهامی' });
                                    break;
                                case 6:
                                    this.users.push({ key: 'نوع شرکت', value: 'مختلط سهامی' });
                                    break;
                                case 7:
                                    this.users.push({ key: 'نوع شرکت', value: 'نسبی' });
                                    break;
                                case 8:
                                    this.users.push({ key: 'نوع شرکت', value: 'تعاونی' });
                                    break;
                                case 9:
                                    this.users.push({ key: 'نوع شرکت', value: 'دولتی' });
                                    break;
                                case 10:
                                    this.users.push({ key: 'نوع شرکت', value: 'وزارتخانه' });
                                    break;
                                case 11:
                                    this.users.push({ key: 'نوع شرکت', value: 'سفارتخانه' });
                                    break;
                                case 12:
                                    this.users.push({ key: 'نوع شرکت', value: 'مسجد' });
                                    break;
                                case 13:
                                    this.users.push({ key: 'نوع شرکت', value: 'مدرسه' });
                                    break;
                                case 14:
                                    this.users.push({ key: 'نوع شرکت', value: 'NGO' });
                                    break;
                            }
                            this.users.push({ key: 'نام شرکت', value: val.user_settings.hoghoghi_account_info.sherkat_name }, { key: 'شماره ثبت شرکت', value: val.user_settings.hoghoghi_account_info.sherkat_sabt_num });
                            if (val.user_settings.hoghoghi_account_info.sherkat_sabt_date == '0001-01-01T00:00:00Z') {
                                this.users.push({ key: 'تاریخ ثبت شرکت', value: '---' });
                            } else {
                                this.users.push({ key: 'تاریخ ثبت شرکت', value: this.$moment(val.user_settings.hoghoghi_account_info.sherkat_sabt_date, 'YYYY-MM-DD').locale('fa').format('jYYYY-jMM-jDD') });
                            }
                            this.users.push({ key: 'تاریخ ثبت شرکت', value: val.user_settings.hoghoghi_account_info.sherkat_sabt_date }, { key: 'شناسه ملی شرکت', value: val.user_settings.hoghoghi_account_info.sherkat_shenase_melli }, { key: 'کد اقتصادی شرکت', value: val.user_settings.hoghoghi_account_info.sherkat_code_eghtesadi });
                        }
                    });
                })
        },
        get_numbers() {
            this.axios.get('/user_nums/' +
                    '?user_id=' + this.$route.params.id +
                    '&operators_fee=1' +
                    '&gateway_info=1' +
                    '&user_info=1')
                .then(res => {
                    res.data.map(val => {
                        val.gateway_name = val.gateway_info.name;
                        val.operators_fee_name = val.operators_fee.name;
                        if (val.last_used == '0001-01-01T00:00:00Z') {
                            val.last_used = '---';
                        } else {
                            val.last_used = this.$moment(val.last_used, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                        }
                    });
                    this.numbers = res.data;
                })
        },
        get_links() {
            this.axios.get('/user_urls/' +
                    '?user_id=' + this.$route.params.id)
                .then(res => {
                    res.data.map(val => {
                        val.created_at = this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                        if (val.last_send == '0001-01-01T00:00:00Z') {
                            val.last_send = '---';
                        } else {
                            val.last_send = this.$moment(val.last_send, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                        }
                    });
                    this.links = res.data;
                })
        },
        get_token() {
            this.axios.get('/user_tokens/' +
                    '?user_id=' + this.$route.params.id)
                .then(res => {
                    res.data.map(val => {
                        val.created_at = this.$moment(val.created_at, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                        if (val.last_used == '0001-01-01T00:00:00Z') {
                            val.last_used = '---';
                        } else {
                            val.last_used = this.$moment(val.last_used, 'YYYY-MM-DD HH:mm:ss').locale('fa').format('HH:mm:ss jYYYY-jMM-jDD');
                        }
                    });
                    this.tokens = res.data;
                })
        },
        get_fees() {
            let tmp = [];
            this.axios.get('/user_nums/' +
                    '?user_id=' + this.$route.params.id)
                .then(res => {
                    res.data.map(val => {
                        tmp.push(val.operators_fee_id);
                    })
                    tmp = [...new Set(tmp)];
                    tmp.map(val => {
                        this.axios.get('operators_fee/' +
                                '?id=' + val)
                            .then(res => {
                                res.data[0].fee_infos.map(val => {
                                    val.mobile_operator_name = val.mobile_operator.name;
                                })
                                this.fees.push(res.data[0]);
                            })
                    });
                })
        },
        redirect_to(route) {
            this.$router.push(route);
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_user_info_page == false &&
            this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
